<template>
<div id="qualification">
    <br><br>
</div>
<div class="container mt-5">
  <div class="box content-size">
    <p class="title is-5 has-text-centered p-4 qualify ">Qualification</p>
    <hr class="mb-3">
    <div class="box">  
    </div>
    <div class="box">
    
      <div class="title is-4 has-text-centered"><b><u>WORK EXPERIENCE</u></b></div>

      <!-- Ambratel Limited -->
      <div class="box ">
         <b><u>GENIUS DYNAMICS LIMITED</u></b><br>
            Attaché<br>
            2018 JUNE - 2018DECEMBER
            <ul>
            <li>Developed and designed Websites.</li>
            <li>Wordpress installation and set-up.</li>
            <li>Joomla website creation.</li>
            <li> Website hosting and Cpanel control.</li>
            </ul><br><br>
         <b><u>AMBRATEL LIMITED</u></b><br>
        Intern<br>
        FEB 2019-DEC 2019
        <ul>
          <li>Structured cabling installations.</li>
          <li>Preparation of bill of quantities, tenders & technical specification.</li>
          <li>Monitored and maintained computer systems and networks.</li>
          <li>Resolved, diagnosed and solved network problems and relevant software faults.</li>
        </ul>
      </div>
      <br>
       <b><u>AMBRATEL LIMITED</u></b><br>
            Systems Administrator<br>
            2020 JAN - DEC 2020
            <ul>
            <li>Maintained network</li>
            <li>Installed closed circuit cameras and performed other Technician duties.</li>
            <li>Structured cabling services-Design and implementation of LAN infrastructure.</li>
            <li>Identified user issues, diagnosed problems and provided.</li>
            <li>Carried out regular maintenance of the network systems for optimal performance.</li>
            <li>Carried out regular maintenance of the network systems for optimal performance.</li>
            <li>Web design and development</li>
            </ul>
            <br>
            <b> <u>COLLECTION AFRICA LIMITED(CAL AFRICA)</u></b><br>
            LOAN RECOVERY MANAGER<br>

            <ul>
              <li>Maintain loan records.</li>
              <li>Make payment plans for clientele.</li>
              <li>Make follow-up on loans payment and recovery.</li>
              <li>Contact loan defaulters and consider necessary Action.</li>
            </ul><br><br>
             <b><u>PINE PUBLISHERS</u></b><br>
            KISUMU BRANCH MANAGER<br>
            JAN 2022- OCT 2022
            <ul>
            <li>Incharge of sales and marketing of books in Kisumu and western region.</li>
            <li>Making sure local bookshops and store have our books.</li>
            <li>Promoting books to school heads and readers.</li>
            <li>Collecting feedback for authors on their books.</li></ul>
            <br><br>
             <b><u>FANISI ONLINE ACADEMY</u></b><br>
            WEBSITE DESIGNER AND MARKETING WESTERN REGION<br>
            OCTOBER 2022-NOW
            <ul>
              <li>Integrate fanisi plugin.</li>
              <li>Promote fanisi academy tool to local schools and provide support.</li>
              <li>Promote fanisi lessons to learners and schools.</li>
              <li>Design features for fanisi website.</li>
              <li>Prepare learning materials for fanisi users.</li>
            </ul><br><br>
            <b><u>CHESS KENYA</u></b><br>
            CHESS TRAINER AND ARBITER<br>
            April 2023-NOW
            <ul>
              <li>Prepare chess players for tournaments</li>
              <li>Analyze chess games with the players</li>
              <li>Prepare puzzles</li>
              <li>Teaching critical chess analysis</li>
            </ul>
      <!-- More work experiences come here soon... -->

    </div>
  </div>
</div>
<hr>
<div id="Qualification ">
    <br><br> 
    
  
    <u><b><div class="title is-4 center content-size">CORE SKILLS</div></b></u><br><br>
    <div class="section center content-size">
      <ul>
      <li>Knowledge of resource management policies and practices.</li>
      <li>Knowledge of information technology applications, systems and processes.</li>
      <li>Extensive knowledge of computers and software applications with Attention to detail.</li>
      <li>Good installation and troubleshooting abilities.</li>
      </ul>
     
        <br>
    </div>
  
   
   
</div>
</template>

<script>

export default {
    name: 'QualificationComponent',
   
}
</script>
<style>
.qualify{
  text-align: center;
  font-size: 250%;
}
.center{
    text-align: center;
}
.defi{
    font-size: x-large;
    
}.qualification{
 
  padding-left: 45%;
}.content-size{
  font-size: larger;
}
.box{
  padding: 2%;
}
</style>
